
import React from "react";
import { cn } from "@/lib/utils";

interface GlowButtonProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

export const GlowButton = ({
  children,
  className,
  icon,
  ...props
}: GlowButtonProps) => {
  return (
    <div className="group relative inline-flex items-center w-full sm:max-w-sm justify-center gap-4">
      <div className="absolute left-0 top-1/2 h-10 w-full -translate-y-1/2 rounded-md bg-gradient-to-r from-indigo-500 via-pink-500 to-yellow-400 opacity-60 blur-lg filter transition-all duration-1000 group-hover:opacity-100 group-hover:duration-200"></div>
      <a
        role="button"
        className={cn(
          "group relative inline-flex w-full items-center justify-center rounded-md bg-gray-900 px-8 py-2 text-lg font-semibold text-white transition-all duration-200 hover:-translate-y-0.5 hover:bg-gray-800 hover:shadow-lg hover:shadow-gray-600/30",
          className
        )}
        {...props}
      >
        {icon && <span className="mr-2">{icon}</span>}
        {children}
        <svg
          viewBox="0 0 10 10"
          height="10"
          width="10"
          fill="none"
          className="ml-2 mt-0.5 -mr-1 stroke-white stroke-2"
        >
          <path
            d="M0 5h7"
            className="opacity-0 transition group-hover:opacity-100"
          ></path>
          <path
            d="M1 1l4 4-4 4"
            className="transition group-hover:translate-x-[3px]"
          ></path>
        </svg>
      </a>
    </div>
  );
};
